import Vue from 'vue'
import debug from '@zhenguo/jssdk/base/debug'
import getURLSearchParam, { replaceState, pushState, emitRouterChange } from '@zhenguo/jssdk/base/url'
import thumb from '@zhenguo/jssdk/image'
import Cat from './vue-plugins/cat'
import LX from './vue-plugins/lx'
import AgentPlugin from './vue-plugins/agent'
import KNBPlugin from './vue-plugins/knb'
import Toasted from './vue-plugins/toasted'
import Loading from './vue-plugins/loading'
import Router from './vue-plugins/router'
import Clipboard from './vue-plugins/clipboard'
import { genActUrl, genOtherActUrl } from '@zhenguo/jssdk/act-url'

export default function (app: typeof Vue) {
  app.use(Cat)
  app.use(LX)
  app.use(AgentPlugin)
  app.use(KNBPlugin)
  app.use(Toasted)
  app.use(Loading)
  app.use(Router)
  app.use(Clipboard)
  app.prototype.$thumb = thumb
  app.prototype.$getURLSearchParam = getURLSearchParam
  app.prototype.$debug = debug
  app.prototype.$replaceState = replaceState
  app.prototype.$pushState = pushState
  app.prototype.$genActUrl = genActUrl
  app.prototype.$genOtherActUrl = genOtherActUrl
  window.onpopstate = () => {
    emitRouterChange()
  }
}
